import React from 'react';
import './TokenCard.scss';

const formatCurrency = (value) => {
  if (typeof value !== 'number' || isNaN(value)) return '$0.00';
  return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const TokenCard = ({
  iconUrl,
  name,
  symbol,
  amount,
  numericAmount,
  tokenPriceUSD,
  isLoadingPrice,
  storedAt,
  note,
}) => {
  const valueUSD =
    typeof numericAmount === 'number' && typeof tokenPriceUSD === 'number'
      ? numericAmount * tokenPriceUSD
      : null;

  return (
    <div className="token-card">
      <div className="token-card-header">
        <img src={iconUrl} alt={`${name} logo`} className="token-card-icon" />
        <div className="token-card-name-symbol">
          <span className="token-card-name">{name}</span>
          <span className="token-card-symbol">({symbol})</span>
        </div>
      </div>

      <div className="token-card-body">
        <div className="token-card-stats-box">
          <p className="token-card-amount">Amount: {amount}</p>
          <div className="token-card-value">
            {isLoadingPrice ? (
              <p>Loading value...</p>
            ) : valueUSD !== null ? (
              <p>Value: {formatCurrency(valueUSD)}</p>
            ) : (
              <p>Value: N/A</p>
            )}
          </div>
        </div>
      </div>

      {/* Storage location badge */}
      {storedAt && (
        <div className="token-card-stored">
          📍 <span className="token-card-stored-label">{storedAt}</span>
        </div>
      )}

      {/* Optional note */}
      {note && <p className="token-card-note">{note}</p>}
    </div>
  );
};

export default TokenCard;